<app-dialog-simple
  [textContent]="{
    title: 'pop-up.erreur-propriete.titre',
    titleId: 'popup-titre',
    paragraph: 'pop-up.erreur-propriete.texte-' + mode,
    paragraphId: 'popup-texte',
    confirmButton: 'btn.ok'
  }"
  (close)="close()"
  (confirm)="close()"
  icon="assets/images/icon-error-message.svg"
>
</app-dialog-simple>
